/* src/app/reconciliation/reconciliation-container/reconciliation-container.component.scss */
body#themeTag :host ::ng-deep .p-dialog .p-dialog-content {
  padding: 2em;
}
.urgent {
  animation: pulse 1s 5;
}
@keyframes pulse {
  50% {
    border-color: #ff4136;
    border-width: 3px;
  }
}
/*# sourceMappingURL=reconciliation-container.component.css.map */
